import { Img, Text, Heading } from "../../components";
import React from "react";

export default function HomePageIntroductionSection() {
  return (
    <>
      {/* home page introduction section */}
      <div>
        <div className="relative h-[862px] content-center bg-gray-900_02 py-[100px] md:h-auto md:py-5">
          <div className="container-xs flex items-center justify-center gap-3 md:flex-col md:px-5">
            <div className="flex flex-1 flex-col items-start gap-10 md:self-stretch">
              <Heading size="headings" as="h2" className="text-[21px] font-semibold text-white-a700">
                Finance plus tech.
              </Heading>
              <div className="flex flex-col gap-[38px] self-stretch">
                <Text
                  size="textxl"
                  as="p"
                  className="text-[24px] font-normal leading-[140%] text-white-a700 md:text-[22px]"
                >
                  <>
                    Welcome to Tail Risk Global, where finance meets cutting-edge technology to revolutionize portfolio
                    risk management. <br />
                    <br />
                    Our proprietary methodology for illiquid assets such as Private Equity, Real Estate, or Private Debt
                    provides a reliable estimate of the contribution of this asset class to portfolio tail loss
                    diversification. <br />
                    <br />
                    On-the-fly portfolio rebalancing allows on-the-spot investment decision-making by comparing risk
                    across multiple portfolios.
                  </>
                </Text>
                <Text size="textmd" as="p" className="text-[16px] font-normal leading-[150%] text-white-a700_8e">
                  With our platform, you can slice and dice portfolios across various dimensions, identifying key risk
                  concentrations and drilling down to the position level. Assess sensitivity to key risk factors, stress
                  test your portfolio, and receive alerts of risk changes due to material market moves. Because we are
                  Powered by Bloomberg, we can tap into your Bloomberg subscription so that you don&#39;t have to pay us
                  for data you already own.
                </Text>
              </div>
            </div>
            <Img
              src="images/img_graphic_tail.svg"
              alt="Graphic Image"
              className="h-[662px] w-[50%] object-contain md:w-full"
            />
          </div>
          <div className="absolute bottom-0 left-0 right-0 top-0 m-auto h-[424px] w-[32%] rotate-[-30deg] rounded-[232px] bg-gradient" />
        </div>
      </div>
    </>
  );
}
